<template>
  <div
    class="timeline scroll"
    id="automation-timeline"
  >
    <h2>{{ __('Últimas atividades') }}</h2>
    <div class="timeline-centered mt-4">
      <article
        class="timeline-entry"
        v-for="(row, index) in timeline"
        :key="index"
      >
        <div class="timeline-entry-inner">
          <div class="timeline-icon">
            <i :class="row.icon" />
          </div>
          <div class="timeline-label">
            <div
              class="message"
              v-html="row.message"
            />
            <div
              class="time"
              v-b-tooltip.bottom="formatDate(row.created_at)"
            >
              <span class="icon mr-1"><i class="fa fa-clock-o" /></span> {{ row.created_at | ago }}
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  created () {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },

  mounted () {
    this.getTimeline();
    this.handleResize();

    Bus.$on('automationUpdated', (automation) => {
      this.getTimeline();

      this.selected = automation;
    });
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },

  props: ['automation'],

  data () {
    return {
      selected: this.automation,
      timeline: null,
    };
  },

  methods: {
    handleResize () {
      const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      const timeline = document.getElementById('automation-timeline');

      if (timeline) {
        timeline.style.height = `${height}px`;
      }
    },

    handleScroll () {
      const timeline = document.getElementById('automation-timeline');
      const header = document.getElementById('the-header');
      const breadcrumb = document.getElementById('bd-breadcrumb');

      if (timeline && header && breadcrumb) {
        const sticky = header.scrollHeight + breadcrumb.scrollHeight + 70;

        if (window.scrollY > sticky) {
          timeline.classList.add('sticky');
        } else {
          timeline.classList.remove('sticky');
        }
      }
    },

    getTimeline () {
      this.$http.get(`/automation/${this.selected.id}/timeline`)
        .then((response) => {
          this.timeline = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>
